import { makeStyles } from '@material-ui/core/styles'

export const useStyle = makeStyles(() => ({
  checkbox: {
    color: '#173E4B',
    '&.Mui-checked': {
      color: '#173E4B'
    }
  },
  submitButton: {
    backgroundColor: '#173E4B',
    '&:hover': {
      backgroundColor: '#0f2d38'
    },
    '&.Mui-disabled': {
      backgroundColor: '#ccc'
    }
  }
}))
